// Helpers de la couche live (sessions + WebSocket)
import axios from 'axios';

// Vide = same-origin : nginx proxe /api sur le même domaine (staging/prod)
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

// ws(s)://… dérivé de l'URL HTTP du backend (ou de la page en same-origin)
export const wsUrl = (sessionId, token) =>
  `${(BACKEND_URL || window.location.origin).replace(/^http/, 'ws')}/api/ws/sessions/${sessionId}?token=${encodeURIComponent(token)}`;

export const joinSession = (pin, nickname, role) =>
  axios.post(`${API}/sessions/join`, { pin, nickname, role });

export const createSession = (config) =>
  axios.post(`${API}/sessions`, { config });

export const listSessions = () => axios.get(`${API}/sessions`);

export const closeSession = (sessionId) =>
  axios.post(`${API}/sessions/${sessionId}/close`);

/**
 * Ouvre le WebSocket d'une session avec reconnexion automatique simple.
 * handlers : { onMessage, onClose } — onClose(event) n'est appelé que si la
 * fermeture est définitive (kick, session close, jeton refusé).
 * Retourne { send, close }.
 */
export function openSessionSocket(sessionId, token, { onMessage, onClose }) {
  let ws = null;
  let closed = false;
  let retryDelay = 1000;

  const FINAL_CODES = [4401, 4403, 4410]; // non autorisé, kické, session close

  const connect = () => {
    ws = new WebSocket(wsUrl(sessionId, token));
    ws.onmessage = (event) => onMessage(JSON.parse(event.data));
    ws.onopen = () => { retryDelay = 1000; };
    ws.onclose = (event) => {
      if (closed || FINAL_CODES.includes(event.code)) {
        if (!closed && onClose) onClose(event);
        return;
      }
      // Coupure réseau : on retente (plafonné à 10 s)
      setTimeout(connect, retryDelay);
      retryDelay = Math.min(retryDelay * 2, 10000);
    };
  };
  connect();

  return {
    send: (message) => {
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(message));
      }
    },
    close: () => {
      closed = true;
      if (ws) ws.close();
    },
  };
}
